import { alpha, Box, Stack, Text, styled } from '@ltvco/refresh-lib/theme';

export const PromoCompactRoot = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'stretch',
  columnGap: theme.spacing(2.5),
  width: '100%',
  boxSizing: 'border-box',
  padding: theme.spacing(2.5, 1.875),
  borderRadius: theme.spacing(1),
  border: `1px solid ${theme.palette.divider}`,
  background: `linear-gradient(90deg, ${
    theme.palette.primary.light
  } 12%, ${alpha(theme.palette.primary.light, 0.5)} 28%, ${
    theme.palette.common.white
  } 45%)`,
  boxShadow: `0px 1px 3px ${alpha(theme.palette.text.primary, 0.06)}`,
}));

export const PromoCompactIconWell = styled(Box)(({ theme }) => ({
  width: 73,
  minWidth: 73,
  flexShrink: 0,
  alignSelf: 'center',
  height: 73,
  borderRadius: '50%',
  backgroundColor: theme.palette.primary.light,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  overflow: 'hidden',
  '& img': {
    maxWidth: '85%',
    maxHeight: '85%',
    objectFit: 'contain',
  },
}));

export const PromoCompactContent = styled(Stack)({
  flex: 1,
  minWidth: 0,
  width: '100%',
  alignItems: 'flex-start',
});

export const PromoCompactTitle = styled(Text)(({ theme }) => ({
  fontSize: 16,
  fontWeight: 700,
  lineHeight: '24px',
  color: theme.palette.text.primary,
  textAlign: 'left',
  margin: 0,
  width: '100%',
  marginBottom: theme.spacing(0.625),
}));

export const PromoCompactBody = styled(Text)(({ theme }) => ({
  fontSize: 14,
  fontWeight: 400,
  lineHeight: '20px',
  color: theme.palette.text.primary,
  textAlign: 'left',
  margin: 0,
  width: '100%',
}));

export const PromoCompactCtaRow = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(1.875),
  width: '100%',
  display: 'flex',
  justifyContent: 'flex-start',
}));

export const PromoDesktopRoot = styled(Stack)(({ theme }) => ({
  flex: 1,
  alignSelf: 'stretch',
  minHeight: 0,
  minWidth: 0,
  width: '100%',
  boxSizing: 'border-box',
  padding: theme.spacing(2.5, 1.875),
  borderRadius: theme.spacing(1),
  border: `1px solid ${theme.palette.divider}`,
  background: `linear-gradient(180deg, ${
    theme.palette.primary.light
  } 0%, ${alpha(theme.palette.primary.light, 0.35)} 35%, ${
    theme.palette.common.white
  } 55%)`,
}));

export const PromoDesktopInner = styled(Stack)(({ theme }) => ({
  flex: 1,
  minHeight: 0,
  width: '100%',
  alignItems: 'center',
  gap: theme.spacing(2.5),
}));

export const PromoDesktopIconFrame = styled(Stack)({
  width: 73,
  height: 73,
  flexShrink: 0,
  alignItems: 'center',
  justifyContent: 'center',
  '& img': {
    maxWidth: '100%',
    maxHeight: '100%',
    objectFit: 'contain',
  },
});

export const PromoDesktopCopy = styled(Stack)(({ theme }) => ({
  flex: 1,
  minHeight: 0,
  width: '100%',
  alignItems: 'center',
  gap: theme.spacing(1),
}));

export const PromoDesktopTitle = styled(Text)(({ theme }) => ({
  fontSize: 16,
  fontWeight: 700,
  lineHeight: '24px',
  color: theme.palette.text.primary,
  textAlign: 'center',
  margin: 0,
}));

export const PromoDesktopBody = styled(Text)(({ theme }) => ({
  fontSize: 14,
  fontWeight: 400,
  lineHeight: '16px',
  color: theme.palette.text.primary,
  textAlign: 'center',
  margin: 0,
}));

export const PromoDesktopCtaRow = styled(Stack)({
  flexDirection: 'row',
  justifyContent: 'center',
  flexShrink: 0,
  width: '100%',
});
